<mat-chip class="eiq-clickable-chip" [attr.data-testid]="testId ? testId + '-chip' : null" [disableRipple]="true" (removed)="remove.emit(option())">
  <span class="eiq-chickable-chip__text">{{ option().text }}</span>
  <button matChipRemove color="primary" [matTooltip]="closeTooltip()" [attr.data-testid]="testId ? testId + '-remove-button' : null">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
</mat-chip>
